import { useEffect, useReducer } from 'react'

import { getInitialState, getReducer } from './store'
import { Config, ActionTypes } from './types'

export const useSlider = (config: Config = {}) => {
  const reducer = getReducer(config)

  const initialState = getInitialState(config.defaultIsOpen)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    const touchListener = (e: TouchEvent) => {
      const { nodeName } = e.target as HTMLElement

      if (nodeName === 'INPUT' || nodeName === 'BUTTON') {
        return
      }

      if (e.type === 'touchend') {
        dispatch({
          type: ActionTypes.TOUCHEND,
        })

        return
      }
      const { pageX } = e.changedTouches[0]

      dispatch({
        type:
          e.type === 'touchstart'
            ? ActionTypes.TOUCHSTART
            : ActionTypes.TOUCHMOVE,
        payload: pageX,
      })
    }

    if (config.enable) {
      document.addEventListener('touchstart', touchListener)
      document.addEventListener('touchmove', touchListener, {
        passive: false,
      })
      document.addEventListener('touchend', touchListener)
    }

    return () => {
      document.removeEventListener('touchstart', touchListener)
      document.removeEventListener('touchmove', touchListener)
      document.removeEventListener('touchend', touchListener)
    }
  }, [config.enable])
  const clickToggleHandler = () => {
    dispatch({
      type: ActionTypes.TOGGLE,
    })
  }
  const style = config.enable ? state.sliderStyle : {}

  return [style, clickToggleHandler] as const
}
